export default __webpack_public_path__ + "static/media/0x033d942a6b495c4071083f4cde1f17e986fe856c.ff500c7e.png";